import type { AnchorHTMLAttributes } from 'react';

import { IconCircle } from 'components/Icon';
import Img from 'components/Img';
import Link from 'components/Link';
import Text from 'components/Text';
import { cn } from 'utils/classNames';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
	className?: string;
	displayType?: 'block' | 'inline';
	href: string;
	imgSrc: string;
	text: string;
}

/** Small image and text with arrow icon */
export default function MicroContentMediaLink({
	className,
	displayType = 'inline',
	href,
	imgSrc,
	text,
	...attrs
}: Props) {
	return (
		<Link
			{...attrs}
			href={href}
			className={cn(
				'group/media-link overflow-hidden rounded-xs bg-brand text-inverse hover:bg-brandHover forced-colors:border',
				displayType === 'inline' && 'inline-flex align-middle',
				displayType === 'block' && 'flex',
				className,
			)}
		>
			{/* Skip alt text on purpose since the link has a proper text below. */}
			<Img
				src={imgSrc}
				alt=""
				loading="eager"
				width={72}
				height={72}
				className="w-[72px] shrink-0 object-cover"
			/>
			<Text
				as="span"
				styleAs="pSmall"
				className="flex grow items-center px-4 py-2"
			>
				<span className="grow group-hover/media-link:underline">{text}</span>
				<IconCircle name="arrow-forward" variant="base" className="ml-4" />
			</Text>
		</Link>
	);
}
MicroContentMediaLink.displayName = 'MicroContentMediaLink';
